import NoRolesAssign from './NoRolesAssign';

export default NoRolesAssign;
